export default __webpack_public_path__ + "117d70489588db75aec82e8af76ad539.svg";